"use strict";
// @ts-ignore
try {
    self['workbox:precaching:7.4.1'] && _();
}
catch (e) { }
